import ExcelJS from 'exceljs';
import axios from 'axios';

const downloadImage = async (url) => {
    try {
        console.log('url: ', url);
        const response = await axios.get(url, {
            responseType: 'arraybuffer',
            headers: {
                'x-api-key': 'TWIGFARM_API_GATEWAY_WEBSOCKET',
                'Accept': 'image/png,image/jpeg,image/*',
                'Cache-Control': 'no-cache'
            },
            // S3 프리사인드 URL을 위한 설정
            maxRedirects: 0,
            validateStatus: function (status) {
                return status >= 200 && status < 300; // 기본값
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error downloading image:', error);
        if (error.response) {
            console.error('Response status:', error.response.status);
            console.error('Response headers:', error.response.headers);
        }
        return null;
    }
};

// 픽셀을 Excel 단위로 변환하는 함수
const pixelsToExcelUnits = {
    // Excel에서 1 width unit은 약 7픽셀
    width: (pixels) => pixels / 7,
    // Excel에서 1 height unit은 약 1.33픽셀
    height: (pixels) => pixels / 1.33
};

export const downloadExcel = async (data) => {
    try {
        console.log('downloadExcel()', data);

        // 새 워크북 생성
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('OCR 결과');

        // 기본 열 설정
        worksheet.columns = [
            { header: '이미지', key: 'image', width: 30 }, // 기본 너비 설정
            { header: 'OCR', key: 'ocr', width: 30 },
            { header: 'OCR PE', key: 'ocrpe', width: 15 }
        ];

        // 헤더 행 높이 설정
        worksheet.getRow(1).height = 20;

        // 데이터 및 이미지 삽입
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            // 행 데이터 추가 (header 이후이므로 첫 데이터 행은 실제 Excel 행 번호 2부터 시작)
            const row = worksheet.addRow({
                ocr: item.ocr,
                ocrpe: item.ocrpe
            });

            // 이미지 다운로드 및 삽입
            const imageData = await downloadImage(item.image);
            if (imageData) {
                // 이미지 추가 (워크북에 이미지 등록)
                const imageId = workbook.addImage({
                    buffer: imageData,
                    extension: 'png'
                });

                // 이미지 크기 계산
                let imageWidth = item.width || 300; // 기본 너비 300px
                let imageHeight = item.height || 200; // 기본 높이 200px

                // 이미지 비율 유지하면서 크기 조정
                const maxWidth = 400; // 최대 너비
                const maxHeight = 300; // 최대 높이
                
                if (imageWidth > maxWidth || imageHeight > maxHeight) {
                    const ratio = Math.min(maxWidth / imageWidth, maxHeight / imageHeight);
                    imageWidth *= ratio;
                    imageHeight *= ratio;
                }

                // Excel 단위로 변환
                const excelWidth = pixelsToExcelUnits.width(imageWidth);
                const excelHeight = pixelsToExcelUnits.height(imageHeight);

                // 열 너비 조정 (이미지 열만)
                worksheet.getColumn(1).width = Math.max(excelWidth, worksheet.getColumn(1).width);

                // 행 높이는 이미지 높이에 맞게 (최소 20)
                row.height = Math.max(excelHeight, 20);

                // 이미지 삽입 (올바른 좌표 객체 사용: tl, ext)
                worksheet.addImage(imageId, {
                    tl: { col: 0, row: row.number - 1 },  // row.number는 1부터 시작하므로 0-index로 보정
                    ext: { width: imageWidth, height: imageHeight },
                    editAs: 'oneCell'
                });
            }
        }

        // Excel 파일 생성 및 다운로드
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob(
            [buffer],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ocr_results.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error('Error creating Excel file:', error);
        throw error;
    }
};
